import styled from "@emotion/styled"

const ListTwelveHeader = styled.div`
  ${({ theme }) => theme.breakpoints.down("lg")} {
    margin-bottom: 30px;
    margin-left: 28px;
  }

  ${({ theme }) => theme.breakpoints.up("lg")} {
    display: flex;
    align-items: center;
  }

  ${({ theme }) => theme.breakpoints.between("lg", "xl")} {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 50px;
    gap: 70px;
  }

  ${({ theme }) => theme.breakpoints.between("xl", "2xl")} {
    column-gap: 70px;
    margin-bottom: 80px;
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    column-gap: 100px;
    margin-bottom: 100px;
  }
`

export default ListTwelveHeader
